import React from 'react';
import { FlexBox, InlineItemWithMargin } from '../Components';
import { getCurrentOrderCustomer } from '../selectors';
import AppContext from '../AppContext';
import { genres } from '../constants';
import { Genre } from './Genre';

import { getTranslateByScope } from '../i18n';
const translations = getTranslateByScope('topbar');

export const GenrePickerComponent = (props) => (
    <AppContext.Consumer>
      {({ actions, ...context }) => {
        const currentOrderCustomer = getCurrentOrderCustomer(context);
        if (!currentOrderCustomer) return null;
        return (
          <FlexBox>
		
            <Genre value={genres.men} actions={actions} />
            <InlineItemWithMargin>
              <Genre value={genres.woman} actions={actions} />
            </InlineItemWithMargin>
            <FlexBox flex="0 1 0" justifyContent="flex-end" alignItems="center" flexGrow={1}>
		<div 
            style={{ cursor: 'pointer' }}
		onClick={props.onCancel}>{translations('close')}</div>
            </FlexBox>
          </FlexBox>
        );
      }}
    </AppContext.Consumer>
);
